import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AUTH_LOGOUT } from './constants';
import Logger from 'utils/logger';

export function logout(reason) {
  return {
    type: AUTH_LOGOUT,
    ...(reason ? { meta: { reason } } : {}),
  };
}

export function useLogout() {
  const dispatch = useDispatch();
  const boundAction = useCallback((...params) => dispatch(logout(...params)), [dispatch]);
  return { logout: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case AUTH_LOGOUT:
      Logger.INFO('Authentication state changed: Unauthenticated');
      return {
        ...state,
        user: null,
        sessionExpired: action.meta && action.meta.reason === 'sessionExpired',
      };
    default:
      return state;
  }
}
